<!--  -->
<template>
  <el-carousel :interval="60000" :height="imgHeight+'px'">
    <el-carousel-item v-for="item in carouselData" :key="item">
      <img :src="item" alt class="img" />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'g-carousel',
  computed: {
    ...mapGetters(['pageData'])
    // dataSource() {
    //   return this.pageData['other']['carousel']
    // }
  },
  mounted() {
    this.carouselData =
      this.pageData['mainMenu'][this.$route.meta.main]['carousel']
    const width =
      document.body.clientWidth > 1920 ? 1920 : document.body.clientWidth
    this.imgHeight = (width / 1940) * 335
    window.addEventListener('resize', () => {
      //  resize:当调整浏览器窗口的大小时触发事件
      const width =
        document.body.clientWidth > 1920 ? 1920 : document.body.clientWidth
      this.imgHeight = (width / 1940) * 335
    })
  },
  watch: {
    $route(to, form) {
      // console.log('to', to)
      const key = to.meta.main
      this.carouselData = this.pageData['mainMenu'][key]['carousel']
    }
  },
  data() {
    return {
      carouselData: [],
      imgHeight: 330
    }
  }
}
</script>
<style lang='less' scoped>
.img {
  .wh(100%) !important;
  margin: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/gCarousel.vue